import * as FlexLayout from 'flexlayout-react';

export const createSymbolModel = () =>
  FlexLayout.Model.fromJson({
    global: { tabSetEnableDeleteWhenEmpty: false, splitterSize: 1 },
    borders: [],
    layout: {
      type: 'row',
      weight: 100,
      children: [
        {
          type: 'tabset',
          weight: 100,
          id: 'main-tabs',
          children: []
        }
      ]
    }
  });

export const createTimeframeModel = (symbol?: string) =>
  FlexLayout.Model.fromJson({
    global: { tabEnableClose: false, splitterSize: 1 },
    borders: [],
    layout: {
      type: 'row',
      weight: 100,
      children: [
        {
          type: 'tabset',
          weight: 100,
          id: `${symbol}-timeframes`,
          enableDeleteWhenEmpty: false,
          enableDrag: false,
          enableDrop: false,
          enableClose: false,
          children: []
        }
      ]
    }
  });

export const createWidgetModel = (hasIndicators: boolean = false) => {
  const children = [
    {
      type: 'tabset',
      weight: hasIndicators ? 65 : 100,
      children: [
        {
          type: 'tab',
          name: 'Main Chart',
          component: 'chart'
        }
      ]
    }
  ];

  if (hasIndicators) {
    children.push({
      type: 'tabset',
      weight: 35,
      id: 'indicators-tabset',
      children: [
        {
          type: 'tab',
          name: 'Indicators',
          component: 'indicators'
        }
      ]
    } as any);
  }

  return FlexLayout.Model.fromJson({
    global: {
      tabEnableClose: false,
      tabEnableDrag: false,
      tabSetEnableDrag: false,
      tabSetEnableDrop: false,
      tabSetEnableTabStrip: false,
      splitterSize: 1,
      tabSetEnableDeleteWhenEmpty: true
    },
    borders: [],
    layout: {
      type: 'row',
      weight: 100,
      children: [
        {
          type: 'row',
          id: 'main-row',
          children
        }
      ]
    }
  });
};
